import { render, staticRenderFns } from "./ForSale.vue?vue&type=template&id=39faa3f2&"
import script from "./ForSale.vue?vue&type=script&lang=js&"
export * from "./ForSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports